import axios from 'axios'
import config from '../config';
import { getRequestHeaders } from './common.service';

const getUserDetails = async (userId) => {
    try {
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.apiUrl + '/users/' + userId, { headers: headers });
        } catch (error) {
            return error.response?.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
};

export { getUserDetails };